import Util from '@/lib/util'
export default [
    {
        title:Util.L('SoRequestCode'),
        key:'soRequestCode',
        width:150
    },
    {
        title:Util.L('SoCode'),
        key:'code',
        width:150
    },{
        title:Util.L('ExternalPoCode'),
        key:'externalCode',
        width:150
    },{
        title:Util.L('AOGroupCode'),
        key:'aoGroupCode',
        width:150
    },{
        title:Util.L('Status'),
        key:'statusName',
        width: 120
    },
    {
        title:Util.L('OutboundMode'),
        key:'outboundModeName',
        width: 120
    },{
        title:Util.L('CustomerName'),
        key:'customerName',
        width: 120
    }, {
        title:Util.L('PackageQty'),
        key:'packageQty',
        width: 120,
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.packageQty));
        }
    },
    {
        title:Util.L('PackageRTShipQty'),
        key:'packageRTShipQty',
        width: 120,
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.packageRTShipQty));
        }
    },
    {
        title:Util.L('PackageShippedQty'),
        key:'packageShippedQty',
        width: 120,
        align:"right",
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.packageShippedQty));
        }
    },{
        title:Util.L('CreationTime'),
        key:'creationTime',
        width: 200,
        render:(h:any,params:any)=>{
            return h("span", Util.toViewDateString(params.row.creationTime));
        }
    }]